// extracted by mini-css-extract-plugin
export default {"header":"Header_header__USWby","logo":"Header_logo__bz+C-"};